import React from 'react';

interface MemberLookupMapDrawStatsProps {
  shapeCount: number;
  areaKm2: number;
}

function formatAreaKm2(areaKm2: number): string {
  const rounded = Math.round(areaKm2 * 100) / 100;
  const display = Number.isInteger(rounded)
    ? String(rounded)
    : rounded.toFixed(2);
  return `${display} km²`;
}

const containerStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: '0.75rem',
  right: '0.75rem',
  display: 'flex',
  alignItems: 'stretch',
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.12)',
  zIndex: 1000,
  padding: '0.75rem 0'
};

const itemStyle: React.CSSProperties = {
  flex: '1 1 50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '0 1.25rem',
  minWidth: '7rem'
};

const dividerStyle: React.CSSProperties = {
  width: '1px',
  alignSelf: 'stretch',
  backgroundColor: '#e5e7eb',
  flexShrink: 0
};

const valueStyle: React.CSSProperties = {
  fontSize: '20px',
  fontWeight: 600,
  color: '#161616',
  lineHeight: 1.2,
  whiteSpace: 'nowrap'
};

const labelStyle: React.CSSProperties = {
  fontSize: '13px',
  color: '#6A7282',
  marginTop: '0.25rem',
  lineHeight: 1.2
};

const MemberLookupMapDrawStats: React.FC<MemberLookupMapDrawStatsProps> = ({
  shapeCount,
  areaKm2
}) => {
  const stats = [
    { label: 'Feature(s) drawn', value: String(shapeCount) },
    { label: 'Total area', value: formatAreaKm2(areaKm2) }
  ];

  return (
    <div style={containerStyle}>
      {stats.map((stat, index) => (
        <React.Fragment key={stat.label}>
          {index > 0 && <div style={dividerStyle} />}
          <div style={itemStyle}>
            <div style={valueStyle}>{stat.value}</div>
            <div style={labelStyle}>{stat.label}</div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default React.memo(MemberLookupMapDrawStats);
